<style>
  .lower-canvas{
    width: 766.5px;
    height: 100%;
    touch-action: none;
    user-select: none;
  }
</style>
<template>
  <div>
    <h2>
      TestCanvas
    </h2>

    <img
      v-show="false"
      ref="myImg"
      src="https://api.efclink.com/api/upload/online/4"
    >
    <canvas
      class="lower-canvas"
      ref="myCanvas"
      width="500"
      height="300"
      style="border:1px solid #c3c3c3;"
    >
    </canvas>
    <button
      @click="downloadCanvas">
      下载
    </button>
  </div>
</template>

<script>
  export default {
    name: "TestCanvas" ,
    data () {
      return {
      }
    },
    mounted: function () {
      console.log("挂载成功") ;
      var c=this.$refs.myCanvas ;
      var ctx=c.getContext("2d");
      ctx.font="10px Arial";
      // 打水印
      ctx.fillText("陈军伟",260,90);
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/test/TestCanvas.vue